import React from "react";
import styled, { keyframes } from "styled-components";
import { apolloSpaceInset1X, apolloSpaceInset2X, apolloSpaceInset3X, apolloSpaceInsetHalfX, } from "@nexthink/apollo-tokens";
import Flex from "../box/Flex";
import { scrollbarMargin } from "../../theme/nativeScrollbars";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import { StyledExtra, StyledHeadingSpacer } from "./ContainerHeader.style";
import ThemeProvider from "../../theme/ThemeProvider";
import Box from "../box/Box";
const ANIMATION_NAME = keyframes({
    "0%": { left: "-100%" },
    "50%": { left: "0%" },
    "100%": { left: "-100%" },
});
const ANIMATION_DURATION = "1.6s";
const ANIMATION_FUNCTION = "ease-in-out";
const BORDER_RADIUS = 4;
const STROKE_WIDTH = 1;
const LOADER_HEIGHT = 4;
export const StyledContainerWrapper = styled((props) => React.createElement(Box, Object.assign({ position: "relative", height: "100%" }, props))).withConfig({ displayName: "StyledContainerWrapper_APC-7281-productShell", componentId: "sc-1mjdsgn" })({});
export const StyledContainer = styled(Flex).withConfig({ displayName: "StyledContainer_APC-7281-productShell", componentId: "sc-fhv2pd" })(({ theme }) => ({
    background: theme.colors.apolloColorBackgroundContainer,
    border: `${STROKE_WIDTH}px solid ${theme.colors.apolloColorStrokeContainer}`,
    borderRadius: `${BORDER_RADIUS}px`,
    height: "100%",
    position: "relative",
    width: "100%",
}));
export const StyledBlueContainer = styled((props) => (React.createElement(ThemeProvider, { theme: "dark" },
    React.createElement(StyledContainer, Object.assign({}, props))))).withConfig({ displayName: "StyledBlueContainer_APC-7281-productShell", componentId: "sc-1m88lkk" })(({ theme }) => ({
    [`&, & ${StyledHeadingSpacer}, & ${StyledExtra}`]: {
        background: theme.colors.apolloColorBackgroundContainerHighlight,
    },
}));
export const StyledMainArea = styled(Flex).withConfig({ displayName: "StyledMainArea_APC-7281-productShell", componentId: "sc-1270537" })(({ hasHeader }) => (Object.assign({ flexDirection: "column", height: "100%", width: "100%", padding: `${apolloSpaceInset3X} 0` }, (!hasHeader && { paddingTop: apolloSpaceInset2X }))));
export const StyledSideArea = styled(Box).withConfig({ displayName: "StyledSideArea_APC-7281-productShell", componentId: "sc-1wu0hsa" })(({ theme, width, variant }) => ({
    background: variant === "blue"
        ? theme.colors.apolloColorBackgroundContainerSideHighlight
        : theme.colors.apolloColorBackgroundContainerSideDefault,
    padding: `0 ${apolloSpaceInset3X}`,
    minWidth: `${width}px`,
    maxWidth: `${width}px`,
}));
export const StyledSideAreaContent = styled(Flex).withConfig({ displayName: "StyledSideAreaContent_APC-7281-productShell", componentId: "sc-f1v1o2" })({
    padding: `${apolloSpaceInset3X} 0`,
    height: "100%",
    overflowX: "auto",
});
export const StyledLoader = styled.div.withConfig({ displayName: "StyledLoader_APC-7281-productShell", componentId: "sc-w10s3i" })({
    borderRadius: `${LOADER_HEIGHT}px ${LOADER_HEIGHT}px 0 0`,
    height: `${LOADER_HEIGHT}px`,
    overflow: "hidden",
    position: "absolute",
    top: 0,
    width: "100%",
    zIndex: 1,
});
export const StyledLoaderBar = styled.div.withConfig({ displayName: "StyledLoaderBar_APC-7281-productShell", componentId: "sc-1wk61ko" }) `animation:${ANIMATION_NAME} ${ANIMATION_DURATION} ${ANIMATION_FUNCTION} infinite;background:${({ theme }) => theme.colors.apolloColorFillLoading};height:100%;position:relative;top:0;width:200%;`;
export const StyledContent = styled(Flex).withConfig({ displayName: "StyledContent_APC-7281-productShell", componentId: "sc-1n9h1rw" })(({ hasHeader }) => ({
    height: "100%",
    margin: `${hasHeader ? apolloSpaceInsetHalfX : 0} ${getValueFromPixelString(apolloSpaceInset1X) - scrollbarMargin}px 0 ${apolloSpaceInset1X}`,
    overflowY: "scroll",
    overflowX: "auto",
    padding: `${apolloSpaceInset1X} ${getValueFromPixelString(apolloSpaceInset1X) - scrollbarMargin}px 0 ${apolloSpaceInset2X}`,
}));
//# sourceMappingURL=Container.style.js.map